import { Auth0PrefixEnum } from '../types/Auth0.js';
export const isAuth0User = (user) => Object.keys(Auth0PrefixEnum.enum).some((prefix) => user.startsWith(`${prefix}|`));
